import { useEffect, type ReactNode } from "react";
import { useAuthStore } from "@/stores/authStore";
import { SetPasswordScreen, SignInScreen } from "./SignInScreen";

/**
 * Wraps the app. Shows nothing until Supabase tells us whether the user is
 * signed in, then renders either the sign-in screen or the real app.
 */
export function AuthGate({ children }: { children: ReactNode }) {
  const { user, ready, bootstrap, passwordPrompt } = useAuthStore();

  useEffect(() => {
    if (!ready) void bootstrap();
  }, [ready, bootstrap]);

  if (!ready) {
    return (
      <div className="min-h-[calc(100vh-40px)] flex items-center justify-center">
        <div className="text-fg-muted text-sm">Loading…</div>
      </div>
    );
  }

  if (!user) return <SignInScreen />;
  if (passwordPrompt) return <SetPasswordScreen />;
  return <>{children}</>;
}
